import React from 'react';

import { Button } from '@welbe/design-system';
import { Container } from './ButtonCollaborators.styles';
import { useNavigate, useLocation } from 'react-router-dom';

interface ButtonCollaboratorsProps {
	onChangeInitialTab: () => void;
	id?: string;
}

export const ButtonCollaborators = ({
	onChangeInitialTab,
	id,
}: ButtonCollaboratorsProps) => {
	const navigate = useNavigate();
	const params = new URLSearchParams(window.location.search);
	const campaignName = params.get('campaignName');
	const { pathname } = useLocation();

	const handleChangeToCollaborators = () => {
		onChangeInitialTab();
		navigate(`${pathname}?campaignName=${campaignName}&communicationId=${id}`);
	};

	return (
		<Container>
			<p>Consulta los resultados de cada colaborador</p>
			<Button onClick={handleChangeToCollaborators} variant="outline">
				Colaboradores
			</Button>
		</Container>
	);
};
